import { render } from "./ViewColumn.vue?vue&type=template&id=ce07dd52"
import script from "./ViewColumn.vue?vue&type=script&lang=js"
export * from "./ViewColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ViewColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce07dd52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce07dd52', __exports__)) {
    api.reload('ce07dd52', __exports__)
  }
  
  module.hot.accept("./ViewColumn.vue?vue&type=template&id=ce07dd52", () => {
    api.rerender('ce07dd52', render)
  })

}


export default __exports__